import styled from 'styled-components';
import { Typography } from '../../global/theme';
import { AlignCenter, FlexCenter, LineClamp } from '../../global/commonStyle';

const FileIconDiv = styled.div`
  position: relative;
  ${FlexCenter}
  .file-text {
    display: flex;
    position: absolute;
    width: 50%;
    font-weight: 700;
    color: var(--text-secondary);
  }
`;

const ReplyMessageDiv = styled.div`
  /* css for file card ui in threaded message */
  .file-div {
    width: 100%;
    ${AlignCenter}
    gap: var(--space-5);
    flex-wrap: wrap;
  }
  .image-div {
    max-width: 240px;
    ${AlignCenter}
    gap: var(--space-4);
    svg {
      min-width: 32px;
      min-height: 32px;
    }
  }

  .filetext {
    color: var(--text-primary);
    ${Typography.body_md_medium}
    margin-top: var(--space-2);
  }
  .reply-text {
    ${Typography.body_md};
    color: var(--text-primary);
    p {
      ${LineClamp(2)}
      margin: var(--space-0);
      padding: var(--space-0);
      a {
        word-break: break-word;
      }
    }
  }
`;

const RecordButton = styled.div`
  svg {
    circle {
      fill: var(--text-secondary);
    }
  }
  &:hover {
    svg {
      circle {
        fill: var(--text-primary);
      }
    }
  }

  .stop-recording {
    svg {
      path {
        fill: var(--accent-error);
      }
      circle {
        fill: var(--accent-error);
      }
    }
  }
`;

export { FileIconDiv, ReplyMessageDiv, RecordButton };
